//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

import ProductsOverviewMedia from './ProductsOverviewMedia.vue';

export default {
  components: {
    CollapseTransition,
    ProductsOverviewMedia,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    supportsShowMore() {
      return this.deal.overview_media.length > 1;
    },
  },
  methods: {
    toggleShow() {
      const top = get(this, ['$refs', 'overviewTop', 'offsetTop']);

      if (this.isOpen && top) {
        window.scrollTo({
          top,
          behavior: 'smooth',
        });
        setTimeout(() => { this.isOpen = false; }, 500);
      } else {
        this.isOpen = true;
      }
    },
  },
};
